import { CloneFilesDriveGroup } from '../domain/models/CloneFilesDriveGroup'
import { CloneRepository } from '../domain/repositories/CloneRepository'
import { CloneDatasource } from './CloneDatasource'

export const cloneRepositoryAdapter = (
  cloneDataDrive: CloneDatasource
): CloneRepository => {
  return {
    async cloneDataDrive(data: CloneFilesDriveGroup, patientId: string) {
      return await cloneDataDrive.cloneDataDrive(data, patientId)
    }
  }
}
